import * as plugins from './lele-serviceworker.plugins';
import * as interfaces from '@losslessone_private/loint-serviceworker';
import { logger } from "./serviceworker.logging";

export class NotificationManager {

  constructor() {
    // this.askPermission();
  }

  public askPermission () {
    Notification.requestPermission((status) => {
      console.log('Notification permission status:', status);
    });
  }
}